import { Middleware } from "redux";
import { DelegationScope, KnownAction, getActingAs } from "../DelegationStore";
import * as TimesheetApprovalStore from "../TimesheetApprovalStore";
import { AppThunkAction, ApplicationState } from "..";

const getRefreshers = (scope: DelegationScope): (() => AppThunkAction<any>)[] =>
    scope === DelegationScope.TimesheetApproval
        ? [TimesheetApprovalStore.actionCreators.loadRequests, TimesheetApprovalStore.actionCreators.loadPendingCount]
        : [];

// Reloads the scope data when the user starts or stops acting on behalf of someone.
const delegationMiddleware: Middleware<{}, ApplicationState> = store => next => (action: KnownAction) => {
    const before = getActingAs(store.getState(), action.scope);
    const result = next(action);
    const after = getActingAs(store.getState(), action.scope);

    if (before?.id !== after?.id) {
        getRefreshers(action.scope).forEach(_ => store.dispatch(_() as any));
    }

    return result;
};

export default delegationMiddleware;
